// import { ref } from "vue";

// import { now } from "core-js/core/date";

import { formatTime, getMonthsRange, getDaysRange } from "./Date.js";
import Cookies from 'quasar/src/plugins/Cookies.js';;
// import { useI18n } from "vue-i18n";
import i18n from '../lang/i18n';
import { getDayOfMonth } from "xe-utils";
import { request } from "@/request/api";
import { saveAs } from 'file-saver';
import ExcelJS from 'exceljs';
import {
  endOfMonth,
  endOfYear,
  startOfMonth,
  startOfYear,
  subMonths,
  subYears,
  addDays,
} from "date-fns";

/**
 * 查找多层数组对象中的某一项
 * @param {Array} data 需要查找的数组对象
 * @param {string} find_val 需要查找的值
 * @param {string} find_field 查找对比的字段名，默认为：id
 * @param {string} next_level_field 下一层的字段名，默认为：children
 * @returns {Array} 返回要查找的对象
 */
function get_array_item(data, find_val, find_field = "id", next_level_field = "children") {
  let return_val = null;

  if (data) {
    Object.values(data).forEach((item) => {
      if (return_val == null) {
        if (item[find_field] === find_val) {
          // 找到
          return_val = item;
        } else {
          // 找孩子
          return_val = get_array_item(item[next_level_field], find_val, find_field, next_level_field);
        }
      }
    })
  }

  return return_val;
}

/**
 * 查找多层数组对象的所有子项
 * @param {Array} data 需要查找的数组对象
 * @param {string} find_val 需要查找的值
 * @param {string} find_field 查找对比的字段名，默认为：id
 * @param {string} next_level_field 下一层的字段名，默认为：children
 * @returns {Array} 返回要查找的对象
 */
function get_array_children(data, find_val, find_field = "id", next_level_field = "children") {
  let return_val = null;

  // if (data) {
  //   Object.values(data).forEach((item) => {
  //     if (return_val == null) {
  //       if (item[find_field] === find_val) {
  //         // 找到
  //         return_val = item;
  //       } else {
  //         // 找孩子
  //         return_val = get_array_children(item[next_level_field], find_val, find_field, next_level_field);
  //       }
  //     }
  //   })
  // }

  return return_val;
}

/**
 * 修改树的可用状态，遍历所有节点设置
 * @param {Array} tree_data 树状全部数据
 * @param {boolean} disabled 可用状态true或false
 * @param {int} node_id 只设置一个节点的状态
 */
function set_tree_disabled(tree_data, disabled, node_id = 0) {
  Object.values(tree_data).forEach((node) => {
    if (node_id > 0) {
      if (node.id == node_id) {
        node.disabled = disabled;
        return true;
      }
    } else {
      node.disabled = disabled;
    }
    // 找孩子
    set_tree_disabled(node.children, disabled, node_id);
  });
}

/**
 * 
 * @param {Array} tree_data 需要设置的树数据
 * @param {int} tree_id 需要修改的ID
 * @param {Array} data 修改后的数据
 */
function set_tree_data(tree_data, tree_id, data) {
  let is_set = false;

  Object.values(tree_data).forEach((node) => {
    if (!is_set) {
      if (node.id = tree_Id) {
        is_set = true;
        node = data;
      }
      // 找孩子
      set_tree_disabled(node.children, tree_id, data);
    }
  });
}

/**
 * 获取表单结构对应字段的默认值
 * @param {Array} form_structure 表单结构
 * @returns {Array} 返回包含默认值的数组
 */
function get_default_value(form_structure) {
  let default_value = {};

  // console.log(Cookies.get('user_info'));
  // console.log(Cookies);
  // console.log(sessionStorage);

  // console.log(form_structure);

  Object.values(form_structure).forEach((row_group) => {
    Object.values(row_group).forEach((field) => {
      if (field.field_name == "id") {
        default_value[field.field_name] = "";
      } else {
        let create_default_type = field.create_default;
        let create_default_value = "";
        let default_ = "";
        // console.log(create_default_type);
        // 处理/转换 创建默认值类型
        if (create_default_type) {
          // console.log(create_default_type);
          // 日期计算
          // if ((create_default_type.indexOf("now") !== -1) && (create_default_type.length > 3)) {

          // }

          // USER_INFO
          if (create_default_type.indexOf("USER_INFO") !== -1) {
            create_default_value = create_default_type.substring(10);
            create_default_type = "USER_INFO";
          }

          // SESSION
          if (create_default_type.indexOf("SESSION") !== -1) {
            create_default_value = create_default_type.substring(8);
            create_default_type = "SESSION";
          }

          // COOKIES
          if (create_default_type.indexOf("COOKIES") !== -1) {
            create_default_value = create_default_type.substring(8);
            create_default_type = "COOKIES";
          }

          //  LOCAL
          if (create_default_type.indexOf("LOCAL") !== -1) {
            create_default_value = create_default_type.substring(6);
            create_default_type = "LOCAL";
          }
        }

        let str_date = "";
        let within = true;
        let param = "";

        if (field.component_type == "editor") {
          if (create_default_type == null) {
            create_default_type = "";
          }
        }

        switch (create_default_type) {
          case "now":
            if (field.component_type == 'month') {
              // default_ = { month: (new Date()).getMonth(), year: (new Date()).getFullYear() };
              default_ = formatTime("yyyy-MM-01");
            } else if (field.component_type == 'daterange') {
              default_ = { 0: formatTime("yyyy-MM-dd"), 1: formatTime("yyyy-MM-dd") };
            } else if (field.component_type == 'datetime') {
              default_ = formatTime("yyyy-MM-dd hh:mm:ss");
            } else {
              // default_ = formatTime("yyyy-MM-dd hh:mm:ss");
              default_ = formatTime("yyyy-MM-dd");
            }
            break;

          case "this_month":
            str_date = (new Date()).getFullYear() + "-" + (parseInt((new Date()).getMonth()) + 1) + "-" + getDayOfMonth(new Date());
            default_ = formatTime("yyyy-MM-01") + ' - ' + formatTime("yyyy-MM-dd", str_date);
            // default_ = [
            //   formatTime("yyyy-MM-01"),
            //   formatTime("yyyy-MM-dd", str_date)
            // ];
            break;

          case "this_year":
            str_date = (new Date()).getFullYear() + "-12-31";
            default_ = formatTime("yyyy-01-01") + ' - ' + formatTime("yyyy-MM-dd", str_date);
            break;

          case "months":
            // 查询及编辑时，字段不同
            param = typeof field.search_operator == "undefined" ? field.verify : field.search_operator;

            // 是否几个月内，即不包含计算结果当天
            within = param.substring(0, 1) == "*";

            // 月份数
            let months_ = parseInt(within ? param.substring(1) : param);

            // 获取当前日期
            str_date = (new Date()).getFullYear() + "-" + (parseInt((new Date()).getMonth()) + 1) + "-" + (new Date()).getDate();

            default_ = getMonthsRange(str_date, months_, within);

            if (field.component_type == "date") {
              default_ = default_[1];
            }

            break;

          case "a_month":
            default_ = formatTime("yyyy-MM-dd", addDays(subMonths(new Date(), 1), 1)) + ' - ' + formatTime("yyyy-MM-dd", new Date());
            break;

          case "last_month":
            param = typeof field.search_operator == "undefined" ? field.verify : field.search_operator;
            within = param.substring(0, 1) == "-";
            // 月份数
            let last_months_ = parseInt(within ? param.substring(1) : param);

            default_ = formatTime("yyyy-MM-dd", addDays(subMonths(new Date(), last_months_), 1));
            default_ += ' - ';
            default_ += formatTime("yyyy-MM-dd", new Date());
            break;

          case "days":
            // 查询及编辑时，字段不同
            param = typeof field.search_operator == "undefined" ? field.verify : field.search_operator;

            // 月份数
            let days_ = parseInt(param);

            // 获取当前日期
            str_date = (new Date()).getFullYear() + "-" + (parseInt((new Date()).getMonth()) + 1) + "-" + (new Date()).getDate();

            default_ = getDaysRange(str_date, days_);

            if (field.component_type == "date") {
              default_ = default_[1];
            } else {
              default_ = default_[0] + ' - ' + default_[1];
            }

            break;

          case "USER_INFO":

            default_ = Cookies.get('user_info')[create_default_value];
            break;

          // case "SESSION:user_id":
          //   default_ = Cookies.get(create_default_value);
          //   break;

          case "SESSION":
            default_ = sessionStorage.get(create_default_value);
            break;

          case "COOKIES":
            default_ = Cookies.get(create_default_value);
            break;

          case "LOCAL":
            const get_value = create_default_value.split(',').length > 1 ? create_default_value.split(',') : create_default_value;

            let raw = get_value.length > 1 ? localStorage.getItem(get_value[0]) : localStorage.getItem(get_value);

            if (raw && raw.startsWith("__q_objt|")) {
              raw = raw.substring(9); // 去掉前缀 "__q_objt|"
            }

            let tmp_default = JSON.parse(raw);

            if (get_value.length > 1) {
              tmp_default = tmp_default[get_value[1]];
            }

            default_ = tmp_default;
            break;
          case "true":
            default_ = true;
            break;

          case "false":
            default_ = false;
            break;

          case "null":
            default_ = null;
            break;

          case "get_default":
            default_ = null;
            break;

          default:
            default_ = create_default_type;
            break;
        }
        default_value[field.field_name] = default_;
      }
    })
  })

  return default_value;
}

/**
 * 获取菜单扩展功能是否包含某个功能或其对应的值
 * @param {string} extensions 扩展参数字符 (例如: "new|edit|level-2|label_fields-code,name")
 * @param {string} key 要查找的扩展参数名
 * @returns {boolean|string|number|null} 返回要查询的扩展值
 */
function get_extensions(extensions, key) {
  if (!extensions) return null;

  // 仍然按 | 分割
  let arr_ext = extensions.split("|");
  let retval = null;
  const prefix = key + "-"; // 动态拼接前缀，如 "label_fields-"

  arr_ext.forEach((ext_key) => {
    ext_key = ext_key.trim(); // 去除两端空格，防手抖配置错

    // 情况一：精准匹配旧的布尔值标签（如 "new", "edit"）
    if (ext_key === key) {
      retval = true;
    }
    // 情况二：匹配带参数的标签（如 "level-2", "label_fields-code,name"）
    else if (ext_key.startsWith(prefix)) {
      // 截取连字符后方的所有内容
      let value = ext_key.substring(prefix.length);

      // 特殊处理：如果是 level，保持原来的逻辑转成整数
      if (key === "level") {
        retval = parseInt(value, 10);
      } else {
        retval = value; // 其他参数默认返回字符串
      }
    }
  });

  return retval;
}

/**
 * 获取功能按钮显示状态
 * @param {Array} permission 权限字符串，用于进行对比
 * @param {string} menu_name 菜单名称，如果没有菜单名称，则视为搜索面板请求
 * @param {string} function_list 功能按钮列表，如果没有在列表中，则不显示
 * @param {string} btn_type 要检查的按钮类型：view,edit,delete等
 * @param {boolean} is_view 是否为查询查看状态，查看状态时不显示新增、修改、删除、审核、反审
 * @param {boolean} is_report 是否为报表，报表不显示查看、新增、修改、删除
 * @returns {boolean} 返回是否可显示
 */
function get_visiable_state(permission, menu_name, function_list, btn_type, is_view, is_report) {
  let state = false;

  // 读取权限，优先使用权限状态
  // 未定义时，为搜索面板功能
  if (typeof menu_name == "undefined") {
    state = true;
  } else {
    state =
      permission[menu_name].indexOf(
        "," + btn_type + ","
      ) !== -1;
  }

  if (state) {
    state =
      ("," + function_list + ",").indexOf("," + btn_type + ",") !==
      -1;

    if (btn_type == "new" || btn_type == "edit" || btn_type == "delete") {
      state = state && !is_view;
    }

    // 报表不显示普通操作功能
    if (is_report) {
      if (
        btn_type == "view" ||
        btn_type == "new" ||
        btn_type == "edit" ||
        btn_type == "delete"
      ) {
        state = false;
      }
    }
  }

  return state;
}

/**
 * 格式化日期
 * @param {string} time 需要格式化的日期，字符串或数字，默认为‘’，即当前时间
 * @param {string} format 格式化的格式，默认为：YY-MM-DD hh:mm:ss
 * @returns {string} 格式化后的日期字符串
 */
function format_date(time = '', format = 'YY-MM-DD hh:mm:ss') {
  var date = new Date();

  if (time) {
    date = new Date(time);
  }

  var year = date.getFullYear(),
    month = date.getMonth() + 1,//月份是从0开始的
    day = date.getDate(),
    hour = date.getHours(),
    min = date.getMinutes(),
    sec = date.getSeconds();
  var preArr = Array.apply(null, Array(10)).map(function (elem, index) {
    return '0' + index;
  });////开个长度为10的数组 格式为 00 01 02 03

  var newTime = format.replace(/YY/g, year)
    .replace(/MM/g, preArr[month] || month)
    .replace(/DD/g, preArr[day] || day)
    .replace(/hh/g, preArr[hour] || hour)
    .replace(/mm/g, preArr[min] || min)
    .replace(/ss/g, preArr[sec] || sec);

  return newTime;
}

/**
 * 获取语言包对应下标的文字
 * @param {string} text_name 对应语言包文本下标名称
 * @param {string} text_ext_name 扩展文本下标名称（有扩展时，只使用扩展）
 * @param {string} text_prefix 文本名称前缀（即在名称前面加上前缀后，再查找翻译）
 * @param {string} text_prefix_char 文本名称前缀连接符，直接加在前缀和名称中间
 * @returns 
 */
function get_lang_text(text_name = "", text_ext_name = "", text_prefix = "", text_prefix_char = "") {
  // const { t } = useI18n();
  const { t } = i18n.global;

  let caption = "";

  let test_name = ""; // 尝试查找的下标 前缀+前缀连接符
  let test_name2 = ""; // 尝试查找的下标 单纯下标
  let default_text = ""; // 默认值，当没有找到对应下标时，直接返回默认值，即传入的值

  let text_name_of_number = ""; // 还有末尾数字的，记录下标名称部分
  let text_name_number = "" // 下标名称中的末尾数字

  test_name = text_prefix;
  test_name += text_prefix != "" ? text_prefix_char : "";

  // 有扩展名称，使用扩展名
  if ("" + text_ext_name != "null" && text_ext_name != "") {
    test_name += text_ext_name;
    test_name2 = text_ext_name;
    default_text = text_ext_name;
  } else {
    // 【修改点 1】只有在没有扩展名称、使用原生 text_name 时，才去拆分末尾数字
    var match_number = text_name.match(/^(.*?)(\d+)$/);
    if (match_number) {
      text_name_of_number = match_number[1];
      text_name_number = match_number[2];
    }

    test_name += text_name;
    test_name2 = text_name;
    default_text = text_name;
  }

  // 尝试查找文本下标，带 前缀+连接符
  caption = t(test_name);

  // 如果返回结果 等于 前缀+前缀连接符，即带连接符的下标没有找到
  if (
    caption.substring(0, text_prefix.length + 1) ==
    text_prefix + text_prefix_char
  ) {
    // 尝试查找无 前缀+前缀连接符 （纯下标）的下标文本
    caption = t(test_name2);

    // 没有找到文本时，使用默认值
    if (!caption) {
      caption = default_text;
    }
  } else if (caption == test_name) {
    // 判断是否有后缀数字，如果有，取消数字后转换，再加上后缀数字
    if (test_name2.length > 0) {
      let last_number = test_name2.charAt(test_name2.length - 1);
      if (Number(last_number) > 0) {
        let new_tecaption = test_name2.substring(0, test_name2.length - 1);
        caption = t(new_tecaption);
        if (!caption) {
          caption = default_text;
        } else {
          caption += last_number;
        }
      } else {
        caption = default_text;
      }
    } else {
      caption = default_text;
    }
  }

  // 【修改点 2】如果没有找到对应翻译，且确实存在拆分出来的外部数字时，才进行数字兜底
  if (caption == default_text && text_name_of_number) {
    caption = t(text_name_of_number) + text_name_number;
  }

  caption = caption == '' ? default_text : caption;

  return caption;
}

/**
 * 将图片转换成Base64URL
 * @param {string} url 图片地址（网络图片或者本地图片）
 * @returns 返回转换后的Base64URL
 */
function get_base64_image(url) {
  const img = new Image()
  //因为是网络资源所以会有图片跨域问题产生，此属性可以解决跨域问题，下文详解
  img.setAttribute("crossOrigin", 'anonymous');
  //如果需要兼容ios，这两个顺序一定不能换，先设置crossOrigin后设置src
  img.src = url;
  return new Promise((resolve, reject) => {
    img.onload = () => {
      //canvas基本配置
      const canvas = document.createElement("canvas");
      canvas.width = img.width;
      canvas.height = img.height;
      const ctx = canvas.getContext("2d");
      ctx.drawImage(img, 0, 0, canvas.width, canvas.height);
      resolve({
        success: true,
        //canvas.toDataURL的方法将图片的绝对路径转换为base64编码
        base64: canvas.toDataURL()
      })
    }
    img.onerror = () => {
      reject({ success: false })
    }
  })
}

/**
 * 将数值四舍五入到指定精度
 * @param {number} value 要处理保留小数位的值
 * @param {integer} decimal 小数位精度，默认0
 * @return 返回处理后的数值
 */
function toFixed(value, decimal = 0) {
  let decimal_ = Math.pow(10, decimal);

  value = Math.round((parseFloat(value) + Number.EPSILON) * decimal_) / decimal_;

  return value.toFixed(decimal);
}

/**
 * 计算字符串相似度
 * @param {string} s 被检索字符串
 * @param {string} t 检索字符串
 * @returns 返回相似度
 */
function similarity(s, t) {
  var l = s.length > t.length ? s.length : t.length;
  var d = strSimilarity2Number(s, t);
  return (1 - d / l).toFixed(4);
}

function strSimilarity2Number(s, t) {
  var n = s.length,
    m = t.length,
    d = [];
  var i, j, s_i, t_j, cost;
  if (n == 0) return m;
  if (m == 0) return n;
  for (i = 0; i <= n; i++) {
    d[i] = [];
    d[i][0] = i;
  }
  for (j = 0; j <= m; j++) {
    d[0][j] = j;
  }
  for (i = 1; i <= n; i++) {
    s_i = s.charAt(i - 1);
    for (j = 1; j <= m; j++) {
      t_j = t.charAt(j - 1);
      if (s_i == t_j) {
        cost = 0;
      } else {
        cost = 1;
      }
      d[i][j] = Minimum(d[i - 1][j] + 1, d[i][j - 1] + 1, d[i - 1][j - 1] + cost);
    }
  }
  return d[n][m];
}

function Minimum(a, b, c) {
  return a < b ? (a < c ? a : c) : (b < c ? b : c);
}

function get_checksums() {
  return new Date().getTime() + parseInt(Math.random(new Date().getTime()) * 10000000);
}

/**
 * 
 * @param {integer} user_id 用户ID
 * @param {string} user_name 用户昵称
 * @param {string} menu_name 使用菜单名称
 * @param {string} operate 执行的操作
 * @param {string} main_data 处理数据
 */
function save_operation_log(user_id, user_name, menu_name, operate, main_data) {
  // JL-TODO 未完成的功能

  // 组装数据
  let save_data = {};
  save_data["id"] = "";
  save_data["user"] = user_id;
  save_data["user_name"] = user_name;
  save_data["menu"] = menu_name;
  save_data["operate"] = operate;
  save_data["content"] = main_data;


  // let save_data_arr = JSON.parse(main_data);
  // 整理内容
  // let content = "";
  // Object.keys(main_data).forEach((key) => {
  //   // console.log(key, "||", main_data[key]);
  //   content += key + "=" + main_data[key] + " || ";
  // })

  // save_data["content"] = content.substring(0, content.lastIndexOf(" || "));

  // console.log("content", content);
  // console.log(JSON.stringify(save_data));

  request("save_data", {
    table_name: "t_sys_log",
    menu_name: "sys_log",
    data: save_data,
    detail_data_insert: [],
    detail_data_remove: "",
    detail_data_update: [],
  }).then((res) => {
    // console.log(res);

  });
}

/**
 * 将 Excel 原始二维数组转换为后端需要的兼容格式
 * @param {Array} importSettings - 从 t_sys_import_setting 表获取的配置数组
 * @param {Array} excelRawRows - Excel 解析出来的原始二维数组 e.g. [ [A1, B1, C1], [A2, B2, C2]... ]
 * @param {String} tableName - 主表名 (例如 't_quotation')
 * @returns {Object|Array} 适合直接传给后端的数据结构
 */
export function transformExcelData(importSettings, excelRawRows, tableName) {
  // 1. 转化 Excel 列字母为 0 基准索引 (A -> 0, B -> 1, Z -> 25, AA -> 26)
  const colLetterToIndex = (letter) => {
    if (!letter) return -1;
    const uppLetter = letter.toUpperCase();
    let column = 0;
    const len = uppLetter.length;
    for (let i = 0; i < len; i++) {
      column += (uppLetter.charCodeAt(i) - 64) * Math.pow(26, len - i - 1);
    }
    return column - 1;
  };

  // 将 0 基准索引转换为 Excel 列字母 (0 -> A, 25 -> Z, 26 -> AA, 51 -> AZ...)
  const indexToColLetter = (index) => {
    let letter = '';
    while (index >= 0) {
      letter = String.fromCharCode((index % 26) + 65) + letter;
      index = Math.floor(index / 26) - 1;
    }
    return letter;
  };

  // =================【⭐ 新增：全新自由表单 Form 模式判断】=================
  const isFormMode = importSettings.some(s => s.field === 'sys' && s.excel_field === 'form');

  if (isFormMode) {
    // 【Form 模式核心处理】
    // 干净利落地把整个 Excel 的原始行、列原封不动地转换成“字母Key对象数组”
    // 不跳过第 0 行（Excel第1行），因为主表账头极有可能在顶部
    return excelRawRows.map(row => {
      const rowObj = {};
      if (Array.isArray(row)) {
        row.forEach((cell, colIdx) => {
          const letter = indexToColLetter(colIdx);
          // 统一清洗 undefined 和 null 为空字符串
          rowObj[letter] = cell !== undefined && cell !== null ? cell : '';
        });
      }
      return rowObj;
    });
  }
  // =====================================================================


  // 2. 判断是传统新逻辑（中间过渡的扁平化版本）还是旧逻辑兼容
  const isNewMode = importSettings.some(s => s.excel_field && (s.excel_field.includes('ROW') || /^[A-Z]+\d+$/.test(s.excel_field.toUpperCase())));

  if (!isNewMode) {
    // 【旧逻辑兼容】老客户模板，不做任何处理，直接返回原始数据结构
    const oldDataObj = {};
    for (let index = 1; index < excelRawRows.length; index++) {
      const row = excelRawRows[index];
      const phpRowKey = index + 1;
      const rowObj = {};
      row.forEach((cell, colIdx) => {
        const letter = indexToColLetter(colIdx);
        rowObj[letter] = cell !== undefined ? cell : '';
      });
      oldDataObj[phpRowKey] = rowObj;
    }
    return oldDataObj;
  }

  // =================【原有的中间过渡期扁平化新逻辑】=================
  // （原样保留，确保你以前开发的其他旧模块不受任何重构冲击）
  const breakMarkerConfig = importSettings.find(s => s.field === 'sys' && s.excel_field === 'BREAK_MARKER');
  const startRowConfig = importSettings.find(s => s.field === 'sys' && s.excel_field === 'start_row');
  const startRow = startRowConfig ? parseInt(startRowConfig.default, 10) : 2;

  let breakRow = -1;
  if (breakMarkerConfig && breakMarkerConfig.join_field) {
    const checkColIdx = colLetterToIndex(breakMarkerConfig.join_field);
    const markerText = String(breakMarkerConfig.default).trim();

    for (let r = startRow - 1; r < excelRawRows.length; r++) {
      if (excelRawRows[r] && checkColIdx >= 0) {
        const cellValue = String(excelRawRows[r][checkColIdx] || '').trim();
        if (cellValue.includes(markerText)) {
          breakRow = r + 1;
          break;
        }
      }
    }
  }

  const endRow = breakRow !== -1 ? breakRow - 1 : excelRawRows.length;

  const masterValues = {};
  const masterSettings = importSettings.filter(s => s.main_table === tableName && s.field !== 'sys');

  masterSettings.forEach(setting => {
    const expr = setting.excel_field;
    if (!expr || expr === 'custom') return;

    let targetRow = -1;
    let targetCol = '';

    if (expr.includes('ROW')) {
      const match = expr.match(/ROW(?:\+([0-9]+))?_([A-Z]+)/i);
      if (match) {
        const offset = match[1] ? parseInt(match[1], 10) : 0;
        targetCol = match[2];
        if (breakRow !== -1) {
          targetRow = breakRow + offset;
        }
      }
    } else {
      const match = expr.match(/^([A-Z]+)([0-9]+)$/i);
      if (match) {
        targetCol = match[1];
        targetRow = parseInt(match[2], 10);
      }
    }

    if (targetRow !== -1 && targetCol) {
      const rIdx = targetRow - 1;
      const cIdx = colLetterToIndex(targetCol);
      const val = excelRawRows[rIdx] ? excelRawRows[rIdx][cIdx] : '';
      masterValues[expr] = val !== undefined ? val : '';
    } else {
      masterValues[expr] = '';
    }
  });

  const finalBackendData = {};
  const detailSettings = importSettings.filter(s => s.main_table === tableName + '_detail' && s.field !== 'sys');

  for (let r = startRow - 1; r < endRow; r++) {
    const rowData = excelRawRows[r];
    if (!rowData) continue;

    const processedRow = {};
    processedRow['A'] = '1';

    Object.keys(masterValues).forEach(mKey => {
      processedRow[mKey] = masterValues[mKey];
    });

    detailSettings.forEach(dSetting => {
      const dbExcelField = dSetting.excel_field;
      if (!dbExcelField || dbExcelField === 'custom') return;

      const parts = dbExcelField.split('_');
      const colLetter = parts[parts.length - 1];
      const cIdx = colLetterToIndex(colLetter);

      if (cIdx >= 0) {
        const val = rowData[cIdx];
        processedRow[dbExcelField] = val !== undefined ? val : '';
      }
    });

    const phpRowKey = r + 1;
    finalBackendData[phpRowKey] = processedRow;
  }

  return finalBackendData;
}

/**
 * 严谨容错版 - 通用 Excel 模板导出函数
 * @param {Object} responseConfig 后端返回的模板主表及明细配置
 * @param {Object} businessData 后端查询到的业务数据（支持对象或原生数组）
 */
async function exportExcelByTemplate(responseConfig, businessData) {
  const { template_url, file_name_rule, details } = responseConfig;

  try {
    // 1. 在线读取 Excel 模板文件
    const response = await fetch(`${template_url}?t=${Date.now()}`); // 加上时间戳防缓存
    if (!response.ok) throw new Error(`读取线上Excel模板失败，状态码: ${response.status}`);
    const templateBuffer = await response.arrayBuffer();

    // 2. 初始化 ExcelJS 工作簿
    const workbook = new ExcelJS.Workbook();
    await workbook.xlsx.load(templateBuffer);
    // const worksheet = workbook.getWorksheet(1); // 默认操作第一个工作表
    // 🎯 改用 worksheets[0]，严格获取整个 Excel 文件里的“第一个可见标签页”，不管它 ID 是几
    const worksheet = workbook.worksheets[0];

    // 🛡️ 加上严谨的安全防御提示
    if (!worksheet) {
      throw new Error("读取模板成功，但未在Excel文件中找到任何有效的工作表(Worksheet)！");
    }

    // 3. 分流处理
    // 3.1 先处理所有的固定单元格 (cell 类型)
    const cellConfigs = details.filter(item => item.mapping_type === 'cell');
    cellConfigs.forEach(config => {
      const cell = worksheet.getCell(config.excel_coordinate);
      // 容错读取：如果是数组就取第一项，如果是对象就按 key 找，找不到找根目录
      let sourceData = businessData;
      if (config.data_key && businessData[config.data_key] !== undefined) {
        sourceData = businessData[config.data_key];
      } else if (Array.isArray(businessData) && businessData.length > 0) {
        sourceData = businessData[0];
      }
      cell.value = sourceData?.[config.db_field] ?? '';
    });

    // 3.2 处理动态列表 (list 类型)
    const listConfigs = details.filter(item => item.mapping_type === 'list');

    // 按照 data_key（如 items）进行分组处理
    const listGroups = groupBy(listConfigs, 'data_key');

    for (const dataKey in listGroups) {
      const configs = listGroups[dataKey];

      // 【智能数据识别补丁】
      let dataset = [];
      if (Array.isArray(businessData)) {
        // 如果传入的 businessData 本身就是数组，直接用它
        dataset = businessData;
      } else if (businessData && businessData[dataKey] !== undefined) {
        // 如果传入的是对象，且包含对应的 key (如 businessData.items)
        dataset = businessData[dataKey];
      }

      if (!dataset || dataset.length === 0) {
        console.warn(`未找到 key 为 [${dataKey}] 的数组数据，跳过该列表生成。`);
        continue;
      }

      // 【起始行容错补丁】：从当前组所有配置中，找出第一个不为 null 的 start_row
      const rowConfig = configs.find(c => c.start_row !== null && c.start_row !== undefined);
      const startRowNumber = rowConfig ? Number(rowConfig.start_row) : 2; // 如果都找不到，默认第 2 行

      // 开始遍历填充列表数据
      dataset.forEach((rowData, index) => {
        const currentRowNumber = startRowNumber + index;

        // 如果超过第一条数据，向下插入新行并完美复制模板行的样式（边框、字体等）
        if (index > 0) {
          worksheet.insertRow(currentRowNumber, []);
          const prevRow = worksheet.getRow(currentRowNumber - 1);
          const currRow = worksheet.getRow(currentRowNumber);
          currRow.height = prevRow.height;
          prevRow.eachCell({ includeEmpty: true }, (cell, colNumber) => {
            const newCell = currRow.getCell(colNumber);
            newCell.style = cell.style;
          });
        }

        // 填入当前行的每一个单元格
        const row = worksheet.getRow(currentRowNumber);
        // configs.forEach(config => {
        //   const cell = row.getCell(config.excel_coordinate); // 此时坐标是列号，如 'A', 'B'
        //   cell.value = rowData[config.db_field] ?? '';
        // });

        configs.forEach(config => {
          const cell = row.getCell(config.excel_coordinate);

          // 🎯 【核心补丁】：如果是自增序号标识，直接填入当前循环的 序号(从1开始)
          if (config.db_field === '_index_') {
            cell.value = index + 1;
          } else {
            // 普通业务字段，依然去拿后端的数据
            cell.value = rowData[config.db_field] ?? '';
          }
        });
      });
    }

    // 4. 动态解析文件名
    const finalFileName = parseFileName(file_name_rule, businessData);

    // 5. 导出并触发浏览器下载
    const buffer = await workbook.xlsx.writeBuffer();
    const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
    saveAs(blob, finalFileName);
    // console.log('Excel 导出成功！');
    return true;
  } catch (error) {
    console.error('导出 Excel 发生错误:', error);
    // alert('导出失败: ' + error.message);
    return error.message;
  }
}

// 辅助函数：根据属性分组
function groupBy(array, key) {
  return array.reduce((result, item) => {
    (result[item[key]] = result[item[key]] || []).push(item);
    return result;
  }, {});
}

/**
 * 智能解析动态文件名（支持多种日期时间格式及业务字段）
 * @param {string} rule 数据库中配置的文件名规则，如 "供应商资料-{datetime}"
 * @param {any} data 业务数据
 */
function parseFileName(rule, data) {
  let name = rule;

  // 1. 获取并格式化当前时间
  const now = new Date();
  const YYYY = now.getFullYear();
  const MM = String(now.getMonth() + 1).padStart(2, '0');
  const DD = String(now.getDate()).padStart(2, '0');
  const hh = String(now.getHours()).padStart(2, '0');
  const mm = String(now.getMinutes()).padStart(2, '0');
  const ss = String(now.getSeconds()).padStart(2, '0');

  // 2. 内置时间占位符替换 (使用全局正则 /g 确保替换所有相同的占位符)
  // 【选项一】{date} -> 2026-06-29
  if (name.includes('{date}')) {
    name = name.replace(/{date}/g, `${YYYY}-${MM}-${DD}`);
  }
  // 【选项二】{datetime} -> 20260629_165227 (最安全易读的文件名时间戳)
  if (name.includes('{datetime}')) {
    name = name.replace(/{datetime}/g, `${YYYY}${MM}${DD}_${hh}${mm}${ss}`);
  }
  // 【选项三】{time} -> 165227
  if (name.includes('{time}')) {
    name = name.replace(/{time}/g, `${hh}${mm}${ss}`);
  }

  // 3. 业务数据字段占位符替换（自动兼容数组和对象）
  const masterData = Array.isArray(data) ? data[0] : (data.master || data);
  const matches = name.match(/\{([a-zA-Z0-9_]+)\}/g) || [];

  matches.forEach(match => {
    const field = match.replace('{', '').replace('}', '');
    // 排除掉已经处理过的内置时间关键字
    if (!['date', 'datetime', 'time'].includes(field) && masterData?.[field] !== undefined) {
      // 全局替换对应的业务字段
      name = name.replace(new RegExp(match, 'g'), masterData[field]);
    }
  });

  // 4. 强力防御：确保后缀一定是 .xlsx 结尾
  return name.endsWith('.xlsx') ? name : `${name}.xlsx`;
}

export default {
  get_array_item,
  get_array_children,
  set_tree_disabled,
  set_tree_data,
  get_default_value,
  get_extensions,
  get_visiable_state,
  format_date,
  get_lang_text,
  get_base64_image,
  toFixed,
  similarity,
  get_checksums,
  save_operation_log,
  transformExcelData,
  exportExcelByTemplate,
}
